<template>
  <div>
    <div style="background: #fff" class="todaySelected-top1">
      <!-- <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="more"
          @load="onLoad"
        > -->

      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(item, index) in list"
          :key="index"
          :name="index"
        >
          <template #title>
            <div class="stock_mybody">
              <div style="width: 2.08rem">
                <div class="top" style="font-size: 0.32rem; font-weight: 500">
                  {{ item.stkName }}
                </div>
                <div class="bottom">
                  {{ item.marketValue }}
                </div>
              </div>
              <div style="width: 1.8rem; font-weight: 500">
                <div class="top">
                  {{ item.stkPrice }}
                </div>
                <div class="bottom">
                  {{ item.buyAvg }}
                </div>
              </div>
              <div style="width: 1.3rem; font-weight: 500">
                <div class="top">
                  {{ item.stkSum }}
                </div>
                <div class="bottom">
                  {{ item.stkBalanceSum }}
                </div>
              </div>

              <div
                style="
                  width: 1.65rem;
                  text-align: right;
                  font-size: 0.34rem;
                  font-weight: 500;
                "
              >
                <div
                  class="top"
                  :class="[
                    item.profit > 0
                      ? 'stock-list-red'
                      : item.profit < 0
                      ? 'stock-list-green'
                      : 'stock-list-333',
                  ]"
                >
                  {{
                    (
                      (Number(item.stkPrice) - Number(item.buyAvg)) *
                      Number(item.stkSum)
                    ).toFixed(2)
                  }}
                </div>
                <div v-if="item.buyAvg>=0"
                  class="bottom"
                  :class="[
                    item.profit > 0
                      ? 'stock-list-red'
                      : item.profit < 0
                      ? 'stock-list-green'
                      : 'stock-list-ccc',
                  ]"
                >
                  {{ item.profitrate }}
                </div>
                <div v-else>--</div>
              </div>
            </div>
          </template>
          <div class="caozuo">
            <div @click="mairuClick(item)">
              <img src="../assets/cc_ic_mairu@2x.png" alt="" />
              <p>买入</p>
            </div>
            <div @click="maichuClick(item)">
              <img src="../assets/cc_ic_maichu@2x.png" alt="" />
              <p>卖出</p>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>

      <!-- <div v-for="(item, index) in list" :key="index">
          <div class="stock_mybody">
            <div style="width: 2.08rem">
              <div class="top" style="font-size: 0.32rem; font-weight: 500">
                {{ item.stkName }}
              </div>
              <div class="bottom">
                {{ item.marketValue }}
              </div>
            </div>
            <div style="width: 1.8rem">
              <div class="top">
                {{ item.stkPrice }}
              </div>
              <div class="bottom">
                {{ item.buyAvg }}
              </div>
            </div>
            <div style="width: 1.3rem">
              <div class="top">
                {{ item.stkSum }}
              </div>
              <div class="bottom">
                {{ item.stkBalanceSum }}
              </div>
            </div>

            <div
              style="
                width: 1.65rem;
                text-align: right;
                font-size: 0.34rem;
                font-weight: bold;
              "
            >
              <div
                class="top"
                :class="[
                  item.profit > 0
                    ? 'stock-list-red'
                    : item.profit < 0
                    ? 'stock-list-green'
                    : 'stock-list-333',
                ]"
              >
                {{ item.profit }}
              </div>
              <div
                class="bottom"
                :class="[
                  item.profit > 0
                    ? 'stock-list-red'
                    : item.profit < 0
                    ? 'stock-list-green'
                    : 'stock-list-ccc',
                ]"
              >
                {{ item.profitrate }}
              </div>
            </div>
          </div>
        </div> -->
      <!-- </van-list> -->
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
export default {
  components: { [Collapse.name]: Collapse, [CollapseItem.name]: CollapseItem },
  props: {
    list: Array,
  },
  data() {
    return {
      activeName: "",
      show: false,
    };
  },
  watch: {
    list: function (newVal, oldVal) {
      //不能用箭头函数
      // console.log(newVal, oldVal);
      if (newVal.lengtn == 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    // console.log(this.list);
  },
  methods: {
    mairuClick(item) {
      this.$router.push({
        path: "/deal?id=0&stkCode=" + item.stkCode + "&market=" + item.market,
      });
    },
    maichuClick(item) {
      // console.log(item);
      this.$router.push({
        path:
          "/deal?id=1&stkCode=" +
          item.stkCode +
          "&market=" +
          item.market +
          "&stkBalanceSum=" +
          item.stkBalanceSum,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main-centent {
  padding: 0 0 0 0.32rem;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.stock_mybody {
  height: 1.2rem;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 0.32rem;
  font-size: 0.3rem;
  // border-bottom: 0.01rem solid #e8e8e8;
}
.stock_mybody .van-collapse-item {
  padding: 0 0 0 0 !important;
}
.bottom {
  font-size: 0.28rem;
  color: #999999;
}
.top {
  color: #333333;
  font-size: 0.36rem;
  line-height: 0.5rem;
}
.stock-list-red {
  color: #f44336;
}
.stock-list-green {
  color: #1aaa52;
}
.stock-list-333 {
  color: #333;
}
.stock-list-ccc {
  color: #999;
}
/deep/.van-cell {
  padding: 0;
}
/deep/.van-collapse-item__content {
  padding: 0;
  font-size: 13px;
}
.caozuo {
  height: 1rem;
  display: flex;
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
  background: rgba(245, 245, 245, 0.5);
  div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666;
    font-size: 0.24rem;
    img {
      width: 0.4rem;
    }
  }
}
.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.7rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}
</style>